import { render, staticRenderFns } from "./v-icon.vue?vue&type=template&id=32f5ae2e&scoped=true&"
import script from "./v-icon.vue?vue&type=script&lang=ts&"
export * from "./v-icon.vue?vue&type=script&lang=ts&"
import style0 from "./v-icon.vue?vue&type=style&index=0&id=32f5ae2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f5ae2e",
  null
  
)

export default component.exports